import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PageLayout } from '../components/layout/PageLayout';
import { useMissingClockOut, useConfirmClockOut, useCheckinStatus } from '../hooks';
import { useToast } from '../components/ui/toast';

export function ConfirmClockout() {
  const { data: items, isLoading } = useMissingClockOut();
  const confirm = useConfirmClockOut();
  const toast = useToast();
  const [actualFor, setActualFor] = useState<string | null>(null);
  const [actualTime, setActualTime] = useState('');
  const { data: status } = useCheckinStatus();

  // บริษัทปิดยืนยันเอง (SELF_CONFIRM_CLOCKOUT=false) — เข้าหน้านี้จากลิงก์เก่า/ค้นหาเมนู ให้พาไปยื่นรับรองเวลาแทน
  if (status?.self_confirm_clockout === false) {
    return (
      <PageLayout title="ยืนยันเวลาเลิกงาน">
        <div className="card p-5 space-y-3">
          <p className="font-medium">บริษัทให้ยื่นขอรับรองเวลาแทน</p>
          <p className="text-sm text-gray-600">
            ลืมสแกนออกงาน ให้ยื่น "รับรองเวลาเข้า-ออกงาน" พร้อมเวลาที่เลิกจริงและเหตุผล แล้ว HR จะตรวจและอนุมัติ
          </p>
          {items && items.length > 0 && (
            <div className="space-y-2">
              {items.map((it) => (
                <Link key={it.date} to={`/attendance-correction?date=${it.date}&kind=evening_out`} className="btn-primary w-full text-sm block text-center">
                  ขอรับรองเวลาเลิกงาน {it.date}
                </Link>
              ))}
            </div>
          )}
          <Link to="/attendance-correction?kind=evening_out" className="btn-secondary w-full text-sm block text-center">
            ไปหน้ารับรองเวลาเข้า-ออกงาน
          </Link>
        </div>
      </PageLayout>
    );
  }

  async function doConfirm(date: string, mode: 'shift_end' | 'actual', actual_time?: string) {
    try {
      await confirm.mutateAsync({ date, mode, actual_time });
      setActualFor(null);
      setActualTime('');
    } catch (e) {
      toast.error(e instanceof Error ? e.message : 'เกิดข้อผิดพลาด');
    }
  }

  return (
    <PageLayout title="ยืนยันเวลาเลิกงาน">
      <p className="text-sm text-gray-600 mb-4">
        วันที่คุณลืมสแกนออกงาน — เลือก “เลิกตามกะ” หรือระบุเวลาจริง เพื่อให้ระบบคิดเวลาให้ถูกต้อง
      </p>

      {isLoading ? (
        <p className="text-sm text-gray-500">กำลังโหลด…</p>
      ) : !items || items.length === 0 ? (
        <div className="card p-6 text-center">
          <p className="text-3xl mb-2">✅</p>
          <p className="font-medium">ไม่มีวันที่ต้องยืนยัน</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((it) => (
            <div key={it.date} className="card p-4">
              <div className="font-medium">{it.date}</div>
              <div className="text-xs text-gray-500 mb-3">ลืมสแกนออกงาน</div>

              {actualFor === it.date ? (
                <div className="space-y-2">
                  <label className="label">เวลาเลิกจริง</label>
                  <input type="time" value={actualTime} onChange={(e) => setActualTime(e.target.value)} className="input" />
                  <div className="flex gap-2">
                    <button onClick={() => { setActualFor(null); setActualTime(''); }} className="btn-secondary flex-1 text-sm">ยกเลิก</button>
                    <button
                      disabled={!actualTime || confirm.isPending}
                      onClick={() => doConfirm(it.date, 'actual', actualTime)}
                      className="btn-primary flex-1 text-sm"
                    >
                      ยืนยันเวลานี้
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex gap-2">
                  <button disabled={confirm.isPending} onClick={() => doConfirm(it.date, 'shift_end')} className="btn-primary flex-1 text-sm">
                    เลิกตามกะ
                  </button>
                  <button onClick={() => setActualFor(it.date)} className="btn-secondary flex-1 text-sm">
                    ระบุเวลาจริง
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </PageLayout>
  );
}
